
export class Audience {
  id: string;
  list_size : string;
  list_age_start_date : string;
  list_age_end_date : string;
  constructor(data?: Partial<Audience>) {
      this.id = data?.id ?? "";
      this.list_size = data?.list_size ?? "";
      this.list_age_start_date = data?.list_age_start_date ?? "";
      this.list_age_end_date = data?.list_age_end_date ?? "";
  }
}
